var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-enterprise-auth"},[_c('div',{staticClass:"title"},[_vm._v("完成云企业认证，尽享更多价值赋能")]),_c('div',{staticClass:"primary-plain-btn",on:{"click":function($event){return _vm.setCloudRegisterPopup(true)}}},[_vm._v("立即前往")])])
}
var staticRenderFns = []

export { render, staticRenderFns }